<template>
  <div>
    <!-- 预览压缩文件-->
    <FileTree ref="fileTreeSearch" :fileTree="fileTree" :fileRow="fileRow" />
    <!-- 预览pdf.word等文件格式 -->
    <Pdf ref="pdfSearch" :src="src" :fileRow="fileRow" />
    <!-- 预览excel.jpg.png.txt等文件格式 -->
    <IframeSrc
      ref="iframeSrcSearch"
      :iframeSrc="iframeSrc"
      :fileRow="fileRow"
    />
    <VideoPlayer ref="videoPlayer" :fileRow="fileRow" />
  </div>
</template>

<script>
import { Message } from "element-ui";
import { mapState } from "vuex";
import req from "@/request.js";
import { Base64 } from "js-base64";
import Pdf from "@/components/common/pdf.vue";
import IframeSrc from "@/components/common/iframeSrc.vue";
import FileTree from "@/components/common/fileTree.vue";
import VideoPlayer from "@/components/common/HtVideoPlayer.vue";

export default {
  components: { Pdf, IframeSrc, FileTree, VideoPlayer, FileTree },
  data() {
    return {
      fileRow: "",
      iframeSrc: "",
      src: "",
      fileTree: "",
    };
  },
  computed: mapState({
    header: (state) => {
      return { Authorization: `Bearer ${state.login.currentUser.token}` };
    },
    actionUrl: function () {
      return req.getContext().portal + "/system/file/v1/upload";
    },
  }),
  mounted() {},
  methods: {
    preview(row) {
      debugger;
      let fileid = row.id;
      if(fileid==undefined || fileid=='undefined'){
        fileid = row.response.fileId;
      }
      let idocType = ["doc","docx","xls","xlsx","ppt","pptx","pdf","txt","jpg","jpeg","gif","png","bmp","tif","mp3","m4a","mid","wma","mp4","zip","rar","tar","7z"];      
      let type;// = row.name.substr(row.name.lastIndexOf(".") + 1);
      this.$http.post(`${window.context.portal}/bpm/aliasScript/v1/execute/FileType?id=${fileid}`).then((resp) => {
         type = resp.data.value[0].FILETYPE;
         debugger;
        setTimeout(() => {
          if (idocType.includes(type)) {
            let token = "testtoken";
            let url = encodeURIComponent(window.context.portal+"/system/file/v1/downloadFile?fileId=" +fileid);
            let idocvUrl = "http://10.10.10.74:8168";
            //***** 外网 *****/
            if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }

            if(window.location.origin.indexOf("http://zs.haiya.com.cn")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }
            
            this.$http.get(`${idocvUrl}/doc/upload?token=${token}&url=${url}`).then((resp) => {
              console.log("预览");
                this.fileRow = row;
                this.iframeSrc = idocvUrl+"/view/" + resp.data.uuid;
                this.$refs.iframeSrcSearch.handleOpen();
              });
          }else{
              this.$http.get(`${window.context.portal}/system/file/v1/downloadFile?fileId=${fileid}`).then((resp) => {
                Message.error("此附件类型暂不支持在线查看，开始为您下载到本地中查看！");
              });
          }
        }, 500);
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.upload-demo {
  max-width: 570px;
  margin-top: 5px;
}
</style>


